module.exports = "/assets/data/7fc64fd68e756e633625c86e70940ac6-RG18.data.json";